import classNames from "classnames";
import { GetStaticProps } from "next";
import { ReactElement, ReactNode, useEffect, useMemo, useState } from "react";
import { NextPageWithLayout } from "./_app";
import TwitchEmbed from "@/components/TwitchEmbed";
import Script from "next/script";
import { HeadMetadata } from "@/components/HeadMetadata";

interface Props {
    siteUrl: string;
}

const Live: NextPageWithLayout<Props> = (props) =>  {
    const [selectedStreamer, setSelectedStreamer] = useState<string | null>(null);
    const streamers = ["tijoe", "SPACEshuttle", "kisumichan", "xmightydragon", "noika__", "Tomatos"];

    const [isTwitchLoaded, setTwitchLoaded] = useState<boolean>(false);

    return (
        <>
            <Script
                src="https://embed.twitch.tv/embed/v1.js"
                onReady={() => setTwitchLoaded(true)}
            />

            <HeadMetadata 
                canonicalUrl={props.siteUrl}
                pageTitle='Мультитрансляция Логова › Тиджой'
                pageDescription='Мультитрансляция всех участников Логова, Twitch-сквада Тиджоя.'
                robots='index,follow'
            />

            {isTwitchLoaded && (
                <>
                    <section className={classNames('relative grid items-center justify-center gap-5 p-5', {'grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 xl:h-screen': selectedStreamer != null, 'grid-cols-1 md:grid-cols-3': selectedStreamer == null})}>
                        {streamers.map((streamer, index) => (
                            <TwitchEmbed 
                                key={index} 
                                channel={streamer} 
                                className={classNames('xl:max-h-[50rem]', {'absolute left-[50%] translate-x-[-50%] z-20 col-span-full order-first': selectedStreamer == streamer})}
                                onSelectedStreamer={setSelectedStreamer}
                                isSelected={selectedStreamer == streamer ? true : false}
                            />
                        ))}
                    </section>
                </>
            )}
        </>
    )
}

Live.getLayout = function getLayout(page: ReactElement) {
    return (
        <>{page}</>
    )
}

export default Live;

export const getStaticProps: GetStaticProps<Props> = async () => {
    return {
      props: {
        siteUrl: process.env['SITE_URL'] as string,
      },
    };
};